module.exports = __webpack_public_path__ + "static/img/1808_4.e682898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_4.jpg
// module id = uzEt
// module chunks = 1